import { useRouterState } from "@tanstack/react-router";

/**
 * Pathname of the route tree that is currently RENDERED.
 *
 * TanStack Router updates `location` as soon as a navigation commits to
 * history, while the previous route tree stays mounted until the new matches
 * finish loading. Components that derive UI from the pathname (tab matching,
 * nav highlighting, title suffixes) must read the pathname of the committed
 * matches instead, or a still-mounted page can react to the destination URL —
 * e.g. RouteTabPage's 404 fallback navigating back and cancelling the
 * transition. react-router swapped location and tree synchronously, so this
 * window did not exist before the migration.
 */
export const useRenderedPathname = (): string =>
  useRouterState({
    select: (s) =>
      s.matches[s.matches.length - 1]?.pathname ?? s.location.pathname,
  });
